export * from '@primeuix/themes/nora/avatar';
export { default } from '@primeuix/themes/nora/avatar';
